export default __webpack_public_path__ + "static/media/brown.78ac9aed.ogg";